import { useMemo } from 'react';
import * as React from 'react';
import { ServiceContextState } from './servicesContext.state';
import { ServicesContext } from './servicesContext';
interface IProps {
  children: React.ReactNode;
  schoolYear?: string;
}

/**
 * ServicesProvider
 * @param children    - Component on which the provider data will be available
 * @param schoolYear  - School year to add in requests
 */
export const ServicesProvider: React.FC<IProps> = ({
  children,
  schoolYear
}) => {
  const options = {
    schoolYear
  };
  const state = useMemo(() => ServiceContextState.newInstance(options), [options]);
  return <ServicesContext.Provider value={state}>{children}</ServicesContext.Provider>;
};